import {configureStore} from '@reduxjs/toolkit'

import Reducers from './modules/rootReducer'


const store = configureStore({
    reducer: {Reducers}
})

export {store}